var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/** @jsx jsx */
import { forwardRef } from 'react';
import { jsx } from 'theme-ui';
export var ListGroup = forwardRef(function (_a, ref) {
    var mobileStyle = _a.mobileStyle, rest = __rest(_a, ["mobileStyle"]);
    return (jsx("div", __assign({ ref: ref, sx: __assign({ '&>div + div': {
                borderTopLeftRadius: 0,
                borderTopRightRadius: 0,
                borderTopWidth: '0 !important',
            } }, (mobileStyle
            ? {
                '&>*:last-child': {
                    borderBottomLeftRadius: [0, 3],
                    borderBottomRightRadius: [0, 3],
                },
                '&>*': {
                    borderWidth: ['0 0 1px 0 !important', '1px !important'],
                    borderTopLeftRadius: ['0 !important', '3px !important'],
                    borderTopRightRadius: ['0 !important', '3px !important'],
                },
            }
            : {
                '&>*:last-child': {
                    borderBottomLeftRadius: 3,
                    borderBottomRightRadius: 3,
                },
            })) }, rest)));
});
//# sourceMappingURL=ListGroup.js.map